import { render, staticRenderFns } from "./productServiceDetail.vue?vue&type=template&id=7c426907&scoped=true"
import script from "./productServiceDetail.vue?vue&type=script&lang=js"
export * from "./productServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./productServiceDetail.vue?vue&type=style&index=0&id=7c426907&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c426907",
  null
  
)

export default component.exports